import Link from "next/link";

interface CTAButtonProps {
    label: string;
    href: string;
    variant?: "primary" | "secondary" | "outline" | "danger" | "disabled";
    className?: string;
    external?: boolean;
}

export default function CTAButton({
    label,
    href,
    variant = "primary",
    className = "",
    external = false,
}: CTAButtonProps) {
    const base = "inline-block font-bold uppercase tracking-wider text-sm transition-all duration-300 rounded-sm text-center";

    const variants = {
        primary: "bg-primary text-black hover:bg-white hover:text-black shadow-lg shadow-primary/30 hover:-translate-y-1 px-8 py-4",
        secondary: "bg-black text-white hover:bg-primary hover:text-black px-8 py-4",
        outline: "bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-black px-8 py-3.5",
        danger: "bg-[#FF3131] text-white hover:opacity-90 shadow-lg shadow-red-500/30 px-8 py-4",
        disabled: "bg-zinc-300 dark:bg-zinc-800 text-zinc-500 dark:text-zinc-400 cursor-not-allowed px-8 py-4 pointer-events-none opacity-70 transform-none hover:translate-y-0 shadow-none",
    };

    const cls = `${base} ${variants[variant as keyof typeof variants]} ${className}`;

    if (external) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>
                {label}
            </a>
        );
    }

    return (
        <Link href={href} className={cls}>
            {label}
        </Link>
    );
}
